<div>
	<mat-expansion-panel
		hideToggle
		class="accordion-item"
		[expanded]="panelExpanded"
		(opened)="panelExpanded = true"
		(closed)="panelExpanded = false"
	>
		<mat-expansion-panel-header class="accordion-header">
			<mat-panel-title class="accordion-title">
                <span class="accordion-name">
                  {{getGroupName(productGroup)}}
                </span>
				<mat-icon class="accordion-done" *ngIf="groupIsMinFull; else Required">done</mat-icon>
			</mat-panel-title>
			<mat-icon [@rotateIt]="panelExpanded ? 'open' : 'closed'">keyboard_arrow_right</mat-icon>
		</mat-expansion-panel-header>

		<div *ngIf="!showGroupAsRadioSelect; else showRadioSelect" class="extra-items">
			<ng-container *ngFor="let mod of productGroup.modifiers; let i = index">
				<div>
					<app-checkbox-select
						[id]="i"
						*ngIf="mod.maxAmount === 1; else showMultipleSelect"
						[groupIsMaxFull]="groupIsMaxFull"
						[(modifier)]="productGroup.modifiers[i]"
						[productSizeId]="item.selectedSizeId"
						(notifyChange)="this.notifyChangeByModifier()"
					>
					</app-checkbox-select>

					<ng-template #showMultipleSelect>
						<app-multiple-select
							[id]="i"
							[(modifier)]="productGroup.modifiers[i]"
							[productSizeId]="item.selectedSizeId"
							[groupIsMaxFull]="groupIsMaxFull"
							(notifyChange)="this.notifyChangeByModifier()"
						>
						</app-multiple-select>
					</ng-template>
				</div>
			</ng-container>
		</div>
	</mat-expansion-panel>
</div>

<ng-template #showRadioSelect>
	<app-radio-select [options]="this.radioModifiers" (notifyChange)="selectRadioModify($event)">
	</app-radio-select>
</ng-template>
<ng-template #Required>
	<div id="{{productGroup.id}}" class="accordion-required">
		<img alt="" class="required-img" src="./assets/img/sheets-icon-required.svg">
		<span>{{"NEED_TO_CHOOSE" | translate}}</span>
	</div>
</ng-template>
